import axios from '../../../utills/axiosConfig';

export const fetchUoms = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/uoms', { params });
  return res.data;
};

export const addUom = async (uom) => {
  try {
    const res = await axios.post('/uoms', uom);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateUom = async (id, uom) => {
  const res = await axios.put(`/uoms/${id}`, uom);
  return res.data;
};

export const deleteUom = async (id) => {
  const res = await axios.delete(`/uoms/${id}`);
  return res.data;
};

export const importUomCSV = async (formData) => {
  const { data } = await axios.post('/uoms/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 